module.exports = __webpack_public_path__ + "img/logo-404.3e856ac.svg";